export function concatenarConGuion(array) {
    return array.join("-");
}


export function capitalizarPrimerLetraCadaPalabra(texto) {
    if(!!texto){
        return texto.replace(/\b\w/g, function(l) {
            return l.toUpperCase();
        }).replace(/\B\w/g, function(l) {
            return l.toLowerCase();
        });
    }
}